import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import NaoPropertiesCls from './NaoPropertiesCls';
import { OrbUserContext } from '../OrbUserContext';


export interface INaoPropertiesProps extends IUseApiProps, IWithErrorHandlingProps {
}

const NaoProperties = (props: INaoPropertiesProps) => {
    const { userPermissions } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <NaoPropertiesCls
                userPermissions={userPermissions}
                {...props}
            />
        </ErrorBoundary>
    );
};

export default withErrorHandling(NaoProperties);
